import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { getSalesHeader } from "../../utils/common/index";

/**
 * Mobile replacement for <select> on sales dashboards: native OS pickers ignore
 * max-width and often draw option lists wider than the viewport. This control
 * keeps the menu within the card width with wrapping text.
 */
export default function MobileSalesTilePicker({
  activeTiles,
  sideValue,
  onSelectIndex,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("touchstart", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("touchstart", close);
    };
  }, [open]);

  if (!activeTiles || activeTiles.length === 0) {
    return null;
  }

  const current = activeTiles[sideValue];
  const label = current
    ? `${current.tileName}${getSalesHeader(current.tileName)}`
    : "Select";

  return (
    <div className="mobile-sales-tile-picker" ref={wrapRef}>
      <button
        type="button"
        className="mobile-sales-tile-picker-toggle form-control text-left d-flex justify-content-between align-items-center"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className="mobile-sales-tile-picker-label">{label}</span>
        <i
          className={`fa fa-angle-${open ? "up" : "down"} flex-shrink-0 ml-2`}
          aria-hidden
        />
      </button>
      {open ? (
        <ul
          className="mobile-sales-tile-picker-menu list-unstyled mb-0"
          role="listbox"
        >
          {activeTiles.map((tile, index) => {
            const text = `${tile.tileName}${getSalesHeader(tile.tileName)}`;
            return (
              <li key={tile.tileId != null ? tile.tileId : `${index}-${text}`}>
                <button
                  type="button"
                  className={`mobile-sales-tile-picker-item ${
                    sideValue === index ? "is-active" : ""
                  }`}
                  role="option"
                  aria-selected={sideValue === index}
                  onClick={() => {
                    onSelectIndex(index);
                    setOpen(false);
                  }}
                >
                  {text}
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}

MobileSalesTilePicker.propTypes = {
  activeTiles: PropTypes.arrayOf(PropTypes.object),
  sideValue: PropTypes.number.isRequired,
  onSelectIndex: PropTypes.func.isRequired,
};
